<template>
    <section>
        <div class="x-content-wrapper">
            <div class="copyright">
                <transition name="fade" mode="out-in">
                    <keep-alive>
                        <router-view></router-view>
                    </keep-alive>
                </transition>

            </div>
        </div>
    </section>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition:.5s;
    opacity: 1;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
section{top:180px;}
.x-content-wrapper{width: 100%; left: 0; right: 0; }
.copyright{max-width: 1260px; margin: 0 auto; text-align: center; }

</style>


// WEBPACK FOOTER //
// src/components/content/content.vue